import { useState } from "react";
import { Globe } from "lucide-react";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";

const LanguageToggle = () => {
  const { language, setLanguage } = useLanguage();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleLanguage = () => {
    setLanguage(language === "fr" ? "en" : "fr");
    setIsDropdownOpen(false);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-1 px-2 py-1.5 rounded-md hover:bg-gray-100 text-gray-700 transition-colors duration-200"
      aria-label="Toggle language"
    >
      <Globe size={18} />
      <span className="text-sm font-medium uppercase">
        {language}
      </span>
    </button>
  );
};

export default LanguageToggle;
